module.exports = __webpack_public_path__ + "img/giraffe.241e5dee.svg";